module["exports"] = [
  "AG",
  "AR",
  "AI",
  "BL",
  "BS",
  "BE",
  "FR",
  "GE",
  "GL",
  "GR",
  "JU",
  "LU",
  "NE",
  "NW",
  "OW",
  "SG",
  "SH",
  "SZ",
  "SO",
  "TI",
  "TG",
  "UR",
  "VD",
  "VS",
  "ZG",
  "ZH",
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/de_CH/address/state_abbr.js
// module id = 2521
// module chunks = 1610